// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Top faculty by keyword — vertical tabs + bar rows ─── */
.KeywordTopFacultySection_section__LMySc {
  padding: 28px 28px 24px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
}

.KeywordTopFacultySection_title__ktwVA {
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
  line-height: 1.25;
  margin: 0 0 6px;
}

.KeywordTopFacultySection_subtitle__accfO {
  font-size: 13px;
  color: var(--grey-text, #888);
  margin: 0 0 20px;
  line-height: 1.45;
}

.KeywordTopFacultySection_layout__wQ1ra {
  display: flex;
  align-items: flex-start;
  gap: 0;
  min-height: 280px;
  max-height: 500px;
  overflow: hidden;
  margin-top: 20px;
}
.KeywordTopFacultySection_layout--desktop__Ss1lW {
  flex-direction: row;
}
.KeywordTopFacultySection_layout--mobile__nBme\\+ {
  flex-direction: column;
}

.KeywordTopFacultySection_vtabs__ef4nV {
  flex: 0 0 220px;
  max-width: 240px;
  min-width: 160px;
  height: 100vh;
  border-right: 1px solid var(--light-grey, #e0e0e0);
}
.KeywordTopFacultySection_vtabs__ef4nV .MuiTabs-flexContainer {
  align-items: stretch;
}
.KeywordTopFacultySection_vtabs__ef4nV .MuiTabs-scroller {
  padding: 8px 0;
}
.KeywordTopFacultySection_vtabs--horizontal__99YEo {
  flex: none;
  max-width: none;
  width: 100%;
  min-width: 0;
  border-right: none;
  border-bottom: 1px solid var(--light-grey, #e0e0e0);
}
.KeywordTopFacultySection_vtabs--horizontal__99YEo .MuiTabs-scroller {
  padding: 4px 0 0;
}

.KeywordTopFacultySection_vtabs-indicator__nut9B {
  background-color: #0f3460;
}

.KeywordTopFacultySection_vtab-item__kDZLc {
  align-items: flex-start;
  text-transform: none;
  font-size: 13px;
  font-weight: 500;
  color: rgba(15, 52, 96, 0.75);
  min-height: 48px;
  padding: 10px 14px;
  text-align: left;
  justify-content: flex-start;
  border-radius: 0;
}
.KeywordTopFacultySection_vtab-item__kDZLc.Mui-selected {
  background: rgba(15, 52, 96, 0.06);
}

.KeywordTopFacultySection_vtab-item-selected__ahMPA {
  color: #0f3460;
  font-weight: 700;
}

.KeywordTopFacultySection_chart-panel__pqmtf {
  flex: 1 1;
  min-width: 0;
  padding: 16px 20px 20px;
  max-height: 520px;
  overflow-y: auto;
}

.KeywordTopFacultySection_empty__lY7Z1 {
  font-size: 14px;
  color: var(--grey-text, #888);
  padding: 24px 8px;
}

.KeywordTopFacultySection_rows__zvZgL {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.KeywordTopFacultySection_row__8dlZt {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) minmax(160px, 3.5fr) auto;
  gap: 12px 14px;
  align-items: center;
}

.KeywordTopFacultySection_avatar__AAd7M {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.KeywordTopFacultySection_avatar-fallback__3fFKm {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(15, 52, 96, 0.1);
  color: #0f3460;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(15, 52, 96, 0.15);
}

.KeywordTopFacultySection_name__4xaKb {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-1, #1a1a1a);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.KeywordTopFacultySection_bar-wrap__N080r {
  height: 10px;
  background: rgba(15, 52, 96, 0.08);
  border-radius: 5px;
  overflow: hidden;
  min-width: 0;
}

.KeywordTopFacultySection_bar-fill__H0FTS {
  height: 100%;
  background: #0f3460;
  border-radius: 5px;
  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1);
}

.KeywordTopFacultySection_count__yFrxj {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #0f3460;
  min-width: 3ch;
  text-align: right;
}

@media only screen and (max-width: 768px) {
  .KeywordTopFacultySection_row__8dlZt {
    grid-template-columns: 40px minmax(0, 1fr);
    grid-template-rows: auto auto;
  }
  .KeywordTopFacultySection_bar-wrap__N080r {
    grid-column: 1/-1;
  }
  .KeywordTopFacultySection_count__yFrxj {
    grid-column: 2/-1;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/KeywordTopFacultySection/KeywordTopFacultySection.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,8DAAA;AAEA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;EACA,mBAAA;AACF;;AAEA;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,MAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,sBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kDAAA;AADF;AAGE;EACE,oBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;AAHJ;AAKI;EACE,gBAAA;AAHN;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;AALF;AAOE;EACE,kCAAA;AALJ;;AASA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,6BAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AANF;;AASA;EACE,aAAA;EACA,oEAAA;EACA,cAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AASA;EACE,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AANF;;AASA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,oDAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AANF;;AASA;EACE;IACE,0CAAA;IACA,6BAAA;EANF;EASA;IACE,iBAAA;EAPF;EAUA;IACE,iBAAA;IACA,gBAAA;EARF;AACF","sourcesContent":["/* ─── Top faculty by keyword — vertical tabs + bar rows ─── */\n\n.section {\n  padding: 28px 28px 24px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n  margin-bottom: 24px;\n}\n\n.title {\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n  line-height: 1.25;\n  margin: 0 0 6px;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: var(--grey-text, #888);\n  margin: 0 0 20px;\n  line-height: 1.45;\n}\n\n.layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  min-height: 280px;\n  max-height: 500px;\n  overflow: hidden;\n  margin-top: 20px;\n\n  &--desktop {\n    flex-direction: row;\n  }\n\n  &--mobile {\n    flex-direction: column;\n  }\n}\n\n.vtabs {\n  flex: 0 0 220px;\n  max-width: 240px;\n  min-width: 160px;\n  height: 100vh;\n  border-right: 1px solid var(--light-grey, #e0e0e0);\n\n  :global(.MuiTabs-flexContainer) {\n    align-items: stretch;\n  }\n\n  :global(.MuiTabs-scroller) {\n    padding: 8px 0;\n  }\n\n  &--horizontal {\n    flex: none;\n    max-width: none;\n    width: 100%;\n    min-width: 0;\n    border-right: none;\n    border-bottom: 1px solid var(--light-grey, #e0e0e0);\n\n    :global(.MuiTabs-scroller) {\n      padding: 4px 0 0;\n    }\n  }\n}\n\n.vtabs-indicator {\n  background-color: #0f3460;\n}\n\n.vtab-item {\n  align-items: flex-start;\n  text-transform: none;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(15, 52, 96, 0.75);\n  min-height: 48px;\n  padding: 10px 14px;\n  text-align: left;\n  justify-content: flex-start;\n  border-radius: 0;\n\n  &:global(.Mui-selected) {\n    background: rgba(15, 52, 96, 0.06);\n  }\n}\n\n.vtab-item-selected {\n  color: #0f3460;\n  font-weight: 700;\n}\n\n.chart-panel {\n  flex: 1;\n  min-width: 0;\n  padding: 16px 20px 20px;\n  max-height: 520px;\n  overflow-y: auto;\n}\n\n.empty {\n  font-size: 14px;\n  color: var(--grey-text, #888);\n  padding: 24px 8px;\n}\n\n.rows {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr) minmax(160px, 3.5fr) auto;\n  gap: 12px 14px;\n  align-items: center;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.avatar-fallback {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(15, 52, 96, 0.1);\n  color: #0f3460;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(15, 52, 96, 0.15);\n}\n\n.name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-1, #1a1a1a);\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bar-wrap {\n  height: 10px;\n  background: rgba(15, 52, 96, 0.08);\n  border-radius: 5px;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.bar-fill {\n  height: 100%;\n  background: #0f3460;\n  border-radius: 5px;\n  transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.count {\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #0f3460;\n  min-width: 3ch;\n  text-align: right;\n}\n\n@media only screen and (max-width: 768px) {\n  .row {\n    grid-template-columns: 40px minmax(0, 1fr);\n    grid-template-rows: auto auto;\n  }\n\n  .bar-wrap {\n    grid-column: 1 / -1;\n  }\n\n  .count {\n    grid-column: 2 / -1;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `KeywordTopFacultySection_section__LMySc`,
	"title": `KeywordTopFacultySection_title__ktwVA`,
	"subtitle": `KeywordTopFacultySection_subtitle__accfO`,
	"layout": `KeywordTopFacultySection_layout__wQ1ra`,
	"layout--desktop": `KeywordTopFacultySection_layout--desktop__Ss1lW`,
	"layout--mobile": `KeywordTopFacultySection_layout--mobile__nBme+`,
	"vtabs": `KeywordTopFacultySection_vtabs__ef4nV`,
	"vtabs--horizontal": `KeywordTopFacultySection_vtabs--horizontal__99YEo`,
	"vtabs-indicator": `KeywordTopFacultySection_vtabs-indicator__nut9B`,
	"vtab-item": `KeywordTopFacultySection_vtab-item__kDZLc`,
	"vtab-item-selected": `KeywordTopFacultySection_vtab-item-selected__ahMPA`,
	"chart-panel": `KeywordTopFacultySection_chart-panel__pqmtf`,
	"empty": `KeywordTopFacultySection_empty__lY7Z1`,
	"rows": `KeywordTopFacultySection_rows__zvZgL`,
	"row": `KeywordTopFacultySection_row__8dlZt`,
	"avatar": `KeywordTopFacultySection_avatar__AAd7M`,
	"avatar-fallback": `KeywordTopFacultySection_avatar-fallback__3fFKm`,
	"name": `KeywordTopFacultySection_name__4xaKb`,
	"bar-wrap": `KeywordTopFacultySection_bar-wrap__N080r`,
	"bar-fill": `KeywordTopFacultySection_bar-fill__H0FTS`,
	"count": `KeywordTopFacultySection_count__yFrxj`
};
export default ___CSS_LOADER_EXPORT___;
